'use strict';

const customerServiceInfoClass = '.js-customer-service-info li';
const customerServiceInfo = $(customerServiceInfoClass);

function initializeEvents() {
    customerServiceInfo.on('click', function(e) {
        e.preventDefault();
        $.ajax({
            type: 'GET',
            url: Urls.getCustomerServiceInfoData,
            success: function(response) {
                window.eventBus.$emit('shouldOpenFlyin', {
                    content: {
                        template: response
                    }
                });
            }
        });
    });
}

const shouldInit = () => document.querySelectorAll(customerServiceInfoClass).length > 0;

const headerCheckout = {
    init: function() {
        if (shouldInit()) {
            require('../../../pages/faqredesign').initCheckout();
            initializeEvents();
        }
    }
};

module.exports = headerCheckout;
